/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorDiaglabAssociation from './doctor-diaglab-association';
import DoctorDiaglabAssociationDetail from './doctor-diaglab-association-detail';
import DoctorDiaglabAssociationUpdate from './doctor-diaglab-association-update';
import DoctorDiaglabAssociationDeleteDialog from './doctor-diaglab-association-delete-dialog';

const DoctorDiaglabAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorDiaglabAssociation />} />
    <Route path="new" element={<DoctorDiaglabAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorDiaglabAssociationDetail />} />
      <Route path="edit" element={<DoctorDiaglabAssociationUpdate />} />
      <Route path="delete" element={<DoctorDiaglabAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorDiaglabAssociationRoutes;
